import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelection } from '../contexts/AppSelectionContext';
import { useExamType } from '../contexts/ExamTypeContext';
import './Header.css';

const Header: React.FC = () => {
  const { selectedApp, setShowModal } = useAppSelection();
  const { getExamTypeName } = useExamType();

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          <h1>Leben in Deutschland Test</h1>
        </Link>
        <div className="header-right">
          <nav className="nav">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/privacy" className="nav-link">Privacy</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
            <Link to="/support" className="nav-link">Support</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
